export default __webpack_public_path__ + "static/media/globe.275805f0.png";